import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#FF8E8E",
    "col1n": "#FF5D5D",
    "col2n": "#FFFFFF"
}
function FacMou105({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col2n}
                    d="M22.55 2.85L0 0l15.5 14.1h14.75L46.8.15l-24.25 2.7z"
                    id="FacMou105__Symbol_192_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1n}
                    d="M56.8.55q-1.7.5-3.6.95-1.65.45-3.25.75l-3.2.55q-4.25.6-8.15.25-1.4-.1-2.7-.35-1.8-.2-3.05-.15-.9 0-1.95.5-.7.3-1.45.85-.15.05-.25.15-.05-.05-.15-.05-.05 0-.1.05-.15-.1-.25-.15-.75-.55-1.4-.85-1.1-.5-2-.5-1.25-.05-3.1.15-1.25.25-2.55.35-3.85.35-8.05-.2Q8.45 2.4 5.15 1.5 2.35.8 0 0q.35.25.65.5.25.2.55.45.05.05.15.1.05 0 .05.05.15.05.3.15l.1.05 6.4 3.85.65-1.35h.1q3.6 1.05 5.65 1.55Q21.8 7 28.95 6.75h.25q7.15.25 14.3-1.4 2.1-.5 5.65-1.55.05 0 .2-.05l.45 1.4 5.8-3.4q.7-.35 1.3-.75.55-.45 1.1-.85-.6.15-1.15.35-.05 0-.05.05z"
                    id="FacMou105__Symbol_193_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M47.95 2.85q-2.5 1.6-4.15 3.2-3.45 3.6-7 5.35-4.55 2.4-8.95 2.4-4.4 0-8.9-2.4-3.6-1.75-7.05-5.35-1.6-1.6-4.15-3.2-.25-.1-1.85-.5Q1.7 1.15 0 0q4.1 3.2 7.4 6.5.1.15.25.25 4.5 4.8 7.8 10 .6 1.05 1.55 2.2 1.95 2.45 5.1 3.75 6.4 2.45 11.6 0 3.1-1.3 5.05-3.75.9-1.15 1.55-2.2 3.25-5.2 7.8-10l.25-.25Q51.6 3.25 55.7.05q-2.3 1.5-5.85 2.3-1.65.4-1.9.5z"
                    id="FacMou105__Symbol_194_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacMou105__Symbol_192_0_Layer0_0_FILL"
                transform="translate(169.85 214.75)"
                id="FacMou105__col2n"
            />
            <use
                xlinkHref="#FacMou105__Symbol_193_0_Layer0_0_FILL"
                transform="translate(163.5 212.15)"
                id="FacMou105__col1n"
            />
            <use
                xlinkHref="#FacMou105__Symbol_194_0_Layer0_0_FILL"
                transform="translate(164.7 213.1)"
                id="FacMou105__col1l"
            />
        </g></g>
    )
}
export default FacMou105
